import {RemotePostResendConfirmEmail} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';
import {PostResendConfirmEmail} from 'domain/usecases';

export const makePostResendConfirmEmail = (): PostResendConfirmEmail =>
	new RemotePostResendConfirmEmail(
		makeBFFApiUrl(ProfileChangeDataEndpoints.resendConfirmEmail),
		makeAuthorizeHttpClientDecorator(),
	);
